import 'date-fns';
import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
// OUTSIDE COMPONENTS
import TextField from '@material-ui/core/TextField';
import Dropdown from 'react-bootstrap/Dropdown'
//CSS, STYLES & MEDIA ASSETS
import variables from "../../assets/bootstrap/scss/_variables.scss"

export default function DropDownF3M(props) {

  return (
    <TextField
      id={props.id}
      className={`text-nowrap ${props.classes}`}
      select
      fullWidth
      color='text'
      label={props.labelText}
      onChange={props.onChangeInput}
      InputLabelProps={{ shrink: true }}
      margin='normal'
      value={props.value}
    >
      {props.dataContent}
    </TextField>
  );
}
